export default "__VITE_ASSET__Dh0tAI3___"